<script setup>

import { defineProps, ref, defineEmits, computed, watch} from "vue";
import Text from "../../../../utils/Text";
import FornecedorService from "../../../../api/v2/services/FornecedorService";
import UtilArray from "../../../../utils/UtilArray.mjs";

//==================================================================//
//========================= Props / Emits ==========================//
//==================================================================//

const props = defineProps([
    "revisandoPedido",
    "pedidoDeCompra",
    "controlesDesativados",
]);

const emits = defineEmits([
    'update:observacoesGerais',
    'update:fornecedorUltimaObservacao',
    'update:controlesDesativados'
]);

//==================================================================//
//=========================== Formulario ===========================//
//==================================================================//

const formulario = ref(null);

//==================================================================//
//=================== Select Observações Gerais ====================//
//==================================================================//

const selectObservacoesGerais = ref(null)

//==================================================================//
//========= Atualizando Observações Gerais do Fornecedor ===========//
//==================================================================//

const atualizandoObservacoesGeraisDoFornecedor = ref(false);

//==================================================================//
//================ Templates de Observações Gerais =================//
//==================================================================//

const templatesObservacoesGerais = ref([
    "O preço estabelecido é fixo e irreajustável.",
    "Os pagamentos serão realizados exclusivamente às quartas-feiras.",
    "Os pagamentos serão realizados exclusivamente às quintas-feiras.",
    "Para o recebimento de parcelas antecipadas, a contratada deverá enviar, obrigatoriamente, um seguro garantia de valor equivalente, devidamente avalizado pelos seus diretores.",
    "O envio dos certificados de qualidade e garantia é obrigatório. A ausência desses documentos resultará no bloqueio do pagamento.",
    "Não será permitido o faturamento antecipado sem autorização expressa da Delta Ducon.",
    "A troca de títulos com empresas de factoring não será aceita sem nossa aprovação prévia.",
    "Fazem parte do escopo da Delta Ducon [detalhar o escopo].",
    "Fazem parte do escopo da contratada [detalhar o escopo].",
    "Integram o pedido de compra os seguintes documentos: [listar documentos].",
]);
const templatesObsevacoesGeraisSelecionados = ref([]);

//==================================================================//
//======================== Desativa Controles ======================//
//==================================================================//

const alternaControlesDesativados = (valor) => {

    emits('update:controlesDesativados', valor);

}

//==================================================================//
//================== Altera Observações Gerais =====================//
//==================================================================//

const alteraObservacoesGerais = (update)=>{

    update.status = validateFormatado.value;
    emits('update:observacoesGerais',{
        ...props.pedidoDeCompra.observacoesGerais,
        ...update
    });

}

//==================================================================//
//============ Altera Observações Gerais Com Template ==============//
//==================================================================//

// Isso foi realizado devido a uma limitação de validate no Formulario.
const alteraObservacoesGeraisComTemplate = (update)=>{

    emits('update:observacoesGerais',{
        ...props.pedidoDeCompra.observacoesGerais,
        ...update
    });

}

//==================================================================//
//================== Altera Observações Gerais =====================//
//==================================================================//

const alteraFornecedorUltimaObservacao = (update)=>{

    emits('update:fornecedorUltimaObservacao',update);

}

//==================================================================//
//====== Altera Atualizando Observações Gerais do Fornecedor =======//
//==================================================================//

const alteraAtualizandoObservacoesGeraisDoFornecedor = (update)=>{

    atualizandoObservacoesGeraisDoFornecedor.value = update;
    alternaControlesDesativados(update);

}

//==================================================================//
//================== Observações Gerais Regras =====================//
//==================================================================//

let observacoesGeraisRegras =  [
    valor => {

        if(Text.greatherOrEqualTo(valor,1)){
            return true;
        }

        return 'As Observações Gerais não podem ser vazias.';

    }
];

//==================================================================//
//============ Seleciona Templates de Observações Gerais ===========//
//==================================================================//

const selecionaTemplatesObservacoesGerais = () =>{

    if(UtilArray.isEmpty(templatesObsevacoesGeraisSelecionados.value)){
        return;
    }

    let observacoesGeraisValor = props?.pedidoDeCompra?.observacoesGerais?.valor?.trim();
    let observacoesGeraisStatus = props?.pedidoDeCompra?.observacoesGerais?.status;

    // Concatena os Template selecionados
    let templatesFormatados = templatesObsevacoesGeraisSelecionados?.value?.reduce((acc,templateSelecionado,index)=>{

        if(index == 0){

            acc += `${templateSelecionado}`;

        }else{

            acc += `\n${templateSelecionado}`;

        }

        return acc;

    },"");

    // Junta os Templates Selecionados ao Texto Digitado
    if(observacoesGeraisValor == ""){

        observacoesGeraisValor = `${observacoesGeraisValor}${templatesFormatados}`;

    }else{

        observacoesGeraisValor = `${observacoesGeraisValor}\n${templatesFormatados}`;

    }

    // Valida se a Observação Geral está Valida ou Invalida;
    observacoesGeraisStatus = observacoesGeraisValor != "" ? "Valido" : "Invalido";

    alteraObservacoesGeraisComTemplate({
        valor: observacoesGeraisValor,
        status: observacoesGeraisStatus
    });

    selectObservacoesGerais.value.blur();
    selectObservacoesGerais.value.reset();

}

//==================================================================//
//=============== Ao Alterar Observações Gerais ====================//
//==================================================================//

const aoAlterarObservacoesGerais = (valor) =>{

    alteraObservacoesGerais({
        valor: valor
    });

}

//==================================================================//
//================= Desativa Observações Gerais ====================//
//==================================================================//

const desativaObservacoesGerais = computed(()=>{

    if(!props?.pedidoDeCompra?.fornecedor?.id || props.controlesDesativados == true){
        return true
    }

    return false;

});


//==================================================================//
//====================== Salvar Observacoes Gerais =================//
//==================================================================//

const atualizaObservacoesGeraisDoFornecedor = async () =>{

    if(!validate()){
        return;
    }

    alteraAtualizandoObservacoesGeraisDoFornecedor(true);

    let fornecedorValores = {
        id: props.pedidoDeCompra.fornecedor.id,
        ultimaObservacao: props.pedidoDeCompra.observacoesGerais.valor
    };

    let fornecedorResponse = await FornecedorService.alterarFornecedor(fornecedorValores);
    if(fornecedorResponse.status != 200){
        throw new Error("Falha ao alterar o Fornecedor");
    }

    alteraFornecedorUltimaObservacao(props.pedidoDeCompra.observacoesGerais.valor);

    alteraAtualizandoObservacoesGeraisDoFornecedor(false);

};

//==================================================================//
//===== Desativa Atualizar Observações Gerais do Fornecedor ========//
//==================================================================//

const desativaAltualizarObservacoesGeraisDoFornecedor = computed(()=>{

    if(!props?.pedidoDeCompra?.observacoesGerais?.valor){
        return true;
    }

    if(!props?.pedidoDeCompra?.fornecedor?.id){
        return true;
    }

    if(props?.controlesDesativados){
        return true;
    }

    return false;

});

//==================================================================//
//================= Cartão Observações Status Cor ==================//
//==================================================================//

const observacoesGeraisStatusCor = computed(()=>{

    if(props?.pedidoDeCompra?.observacoesGerais?.status == "Salvo"){
        return "green";
    }

    if(props?.pedidoDeCompra?.observacoesGerais?.status == "Valido"){
        return "orange";
    }

    return "red"; 

});

//==================================================================//
//============================= Validate ===========================//
//==================================================================//

const validate = () =>{

    return formulario?.value?.validate();

}

//==================================================================//
//====================== Validate Formatado ========================//
//==================================================================//

const validateFormatado = computed(()=>{

    return validate() ? "Valido" : "Invalido";

});

</script>

<template>

    <v-card>

        <v-card-title
            class="c-observacoes-gerais"
        >

            <h3
                class="c-observacoes-gerais__titulo"
            >
                Observações Gerais do Pedido

                <v-chip
                    v-show="props?.pedidoDeCompra?.id"
                    :color="observacoesGeraisStatusCor"
                    dark
                >
                    {{props?.pedidoDeCompra?.observacoesGerais?.status}}
                </v-chip>

            </h3>

            
            <v-btn
                class="c-observacoes-gerais__salvar-observacao"
                color="primary"
                @click="atualizaObservacoesGeraisDoFornecedor"
                :loading="atualizandoObservacoesGeraisDoFornecedor"
                :disabled="desativaAltualizarObservacoesGeraisDoFornecedor"
            >
                Atualizar Observações
            </v-btn>

        </v-card-title>

        <v-form
            ref="formulario"
        >

            <v-select class="c-campo__input"
                ref="selectObservacoesGerais"
                v-model="templatesObsevacoesGeraisSelecionados"
                label="Templates de Observações Gerais"
                :items="templatesObservacoesGerais"
                :disabled="desativaObservacoesGerais"
                outlined
                multiple
                prepend-icon="mdi-vector-arrange-below"
                @blur="selecionaTemplatesObservacoesGerais"
            >
        
                <template v-slot:selection="{ index }">

                    <v-chip 
                        class="primary"
                        v-if="index === 0"
                    >
                        <span>
                            {{ templatesObsevacoesGeraisSelecionados.length}} Templates Selecionados.
                        </span>
                    </v-chip>
                    
                </template>
        
            </v-select>

            <v-textarea
                :value="props?.pedidoDeCompra?.observacoesGerais?.valor"
                outlined
                label="Observações Gerais"
                variant="outlined"
                no-resize
                auto-grow
                :rules="observacoesGeraisRegras"
                :disabled="desativaObservacoesGerais"
                @input="aoAlterarObservacoesGerais"
            >
            </v-textarea>
    
        </v-form>

    </v-card>

</template>

<style scoped>

.c-observacoes-gerais{
    display: grid;
    grid-template-columns: 1fr min-content;
    grid-template-rows: 1fr;
    gap: 10px;
    grid-template-areas:
        "titulo salvarObservacao";
}

.c-observacoes-gerais__titulo{
    grid-area: titulo;
}

.c-observacoes-gerais__salvar-observacao{
    grid-area: salvarObservacao;
    align-self: baseline;
    width: -moz-min-content;
    width: min-content;
    margin-left: auto;
}

</style>